import { Component, inject } from '@angular/core';
import { Router, RouterModule, NavigationEnd } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Subscription, filter } from 'rxjs';
import { SidebarComponent } from "../sidebar/sidebar.component";
import { SecondaryNavComponent } from "../secondary-nav/secondary-nav.component";
import { ChatButtonComponent } from "../chat-button/chat-button.component";
import { LookupButtonComponent } from "../lookup-button/lookup-button.component";
import { SuperAdminUserDialogComponent } from "../super-admin-user-dialog/super-admin-user-dialog.component";
import { SuperAdminUserDialogService } from "../super-admin-user-dialog/super-admin-user-dialog.service";
import { environment } from '../../environments/environment';
import { version } from '../../environments/version';

@Component({
    selector: 'app-main',
    imports: [RouterModule, CommonModule, SidebarComponent, SecondaryNavComponent, ChatButtonComponent, LookupButtonComponent, SuperAdminUserDialogComponent],
    templateUrl: './main.component.html',
    styleUrl: './main.component.css'
})
export class MainComponent {
  private router = inject(Router);
  readonly userDialog = inject(SuperAdminUserDialogService);

  environment: string;
  version = version;
  showSidebar: boolean = false;
  isMobileSidebarOpen: boolean = false;
  private routeSubscription?: Subscription;

  constructor() {
    this.environment = `${environment.name} - ${environment.version}`;
    this.updateSidebarVisibility();
    this.routeSubscription = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.updateSidebarVisibility();
      this.isMobileSidebarOpen = false; // Close mobile sidebar on navigation
    });
  }

  // builtAt is an ISO UTC string; render as "2026-08-08 09:21 UTC"
  get builtAtUtc(): string {
    return version.builtAt ? version.builtAt.slice(0, 16).replace('T', ' ') + ' UTC' : '';
  }

  updateSidebarVisibility() {
    this.showSidebar = this.router.url.startsWith('/venues/');
  }

  toggleMobileSidebar() {
    this.isMobileSidebarOpen = !this.isMobileSidebarOpen;
  }

  ngOnDestroy() {
    this.routeSubscription?.unsubscribe();
  }
}
